import type { ReactNode } from 'react'

import type { Language } from '../../../common/types/i18n.js'
import { Tabs } from '../tabs/tabs.js'

export interface SubNavItem {
    key: string
    label: string
    href: string
}

export interface SubNavProps {
    items: SubNavItem[]
    activeKey: string
    // Optional right-aligned controls (e.g. a page-level action button).
    actions?: ReactNode
    // Pin the row to the top of the scroll container when content scrolls past.
    sticky?: boolean
    // Language for the overflow scroll-arrow labels.
    lang: Language
}

// Cross-route subnavigation row — a thin wrapper over the shared Tabs (underline
// variant). Items are real links (openable in a new tab) that navigate client-side.
export const SubNav = ({ items, activeKey, actions, sticky, lang }: SubNavProps) => (
    <Tabs
        variant="underline"
        items={items}
        activeKey={activeKey}
        actions={actions}
        sticky={sticky}
        lang={lang}
    />
)
